import type { FaireProductEntity } from "../../entity_types/product";

export const p_1dlyjwwg: FaireProductEntity = {
  token: "p_1dlyjwwg",
  type: "product",
  name: "Preggie Snacks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/47ca4ec1687b4fe24a8471d1567c1c84563b53c4006020b6f54ea8ce54302579/1528336688.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/77ef173abb86c5e06a9e8faadf82bdbb1d016d000d17aa55f073e90b136d85d5/1528336688.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:43.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
